import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

import URLField from './URLField';

export default class Company extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  set isFull(bool) {
    this._isFull = bool;
  }

  get isFull() {
    return get(this, '_isFull', false);
  }

  get id() {
    return this.system.id;
  }

  get codename() {
    return this.system.codename;
  }

  get address() {
    return get(this, '_adres.value', '');
  }

  get legalForm() {
    return get(this, '_forma_prawna.value', '');
  }

  get shareCapital() {
    return get(this, '_wysokosc_kapitalu_zakladowego.value', '');
  }

  get registrationCountry() {
    return get(this, '_kraj_rejestracji.value', '');
  }

  get color() {
    return get(this, '_hex_kolor.value', '#000000');
  }

  get logo() {
    return get(this, '_logo.value[0].url', '');
  }

  get photo() {
    return get(this, '_zdjecie_tlo.value[0].url', {});
  }

  get name() {
    return get(this, '_nazwa.value', '');
  }

  get website() {
    const link = get(this, '_strona_www.value');
    return new URLField(link);
  }

  get contact() {
    return get(this, '_kontakt.value', '');
  }

  get courtRegistrationNumber() {
    return get(this, '_krs.value', '');
  }

  get dunsNumber() {
    return get(this, '_duns.value', '');
  }

  get taxIdNumber() {
    return get(this, '_nip.value', '');
  }

  get statisticalNumber() {
    return get(this, '_regon.value', '');
  }

  get shares() {
    return get(this, '_shares.value', '');
  }

  get sneakPeak() {
    return get(this, '_zajawka.value', '');
  }

  get descriptionShort() {
    return get(this, '_opis_krotki.value', '');
  }

  get descriptionLong() {
    return get(this, '_opis_pelny.value', '');
  }

  get descriptionColumn1() {
    return get(this, '_opis_slider_kolumna_1.value', '');
  }

  get descriptionColumn2() {
    return get(this, '_opis_slider_kolumna_2.value', '');
  }

  get descriptionColumn3() {
    return get(this, '_opis_slider_kolumna_3.value', '');
  }

  get achievmentsDescription() {
    return get(this, '_osiagniecia_tresc.value', '');
  }

  get achievmentsImage() {
    return get(this, '_osiagniecia_zdjecie[0].image.url', '');
  }

  get infoBoxesData() {
    return get(this, '_spolka_info_box.value', []);
  }

  get specializationData() {
    return get(this, '_specjalizacja.value', []);
  }

  get products() {
    return get(this, '_produkty.value', []);
  }

  get partners() {
    return get(this, '_partnerzy.value', []);
  }

  get slug() {
    return get(this, '_slug.value', '');
  }

  get subsidiaries() {
    return get(this, '_spolki_zalezne.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/Company.js